@if (dataVisible$ | async) {
  <form [formGroup]="formGroup">
    @if ((formGroup.controls.totaleWeekenduitgaven.value ?? 0) > 0) {
      <div class="row">
        <div class="col col-1">
          <p>Aftrekbare weekenduitgaven gehandicapte kinderen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button (click)="this.showDialog()"
                               [disabled]="(formGroup.controls.totaleWeekenduitgaven.value ?? 0) === 0"
                               class="custom-input-150"
                               icon="eye"
                               type="secondary">Specificatie
          </snelstart-ui-button>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control
            [decimals]="0"
            [disabledControl]="true"
            align="right"
            class="custom-input-150"
            formControlName="totaleWeekenduitgaven"
            id="totaleWeekenduitgaven"
            prefix="€"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-2"></div>
      </div>
    }
    @if ((formGroup.controls.totaalAftrekbareAlimentatie.value ?? 0) > 0) {
      <div class="row">
        <div class="col col-1">
          <p>Aftrekbare alimentatie</p>
        </div>
        <div class="col-2"></div>
        <div class="col-2">
          <snelstart-ui-number-form-control
            [decimals]="0"
            [disabledControl]="true"
            align="right"
            class="custom-input-150"
            formControlName="totaalAftrekbareAlimentatie"
            id="totaalAftrekbareAlimentatie"
            prefix="€"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-2"></div>
      </div>
    }
    @if ((formGroup.controls.totaalRestantPga.value ?? 0) > 0) {
      <div class="row">
        <div class="col col-1">
          <p>Restant persoonsgebonden aftrek voorgaande jaren</p>
        </div>
        <div class="col-2"></div>
        <div class="col-2">
          <snelstart-ui-number-form-control
            [decimals]="0"
            [disabledControl]="true"
            align="right"
            class="custom-input-150"
            formControlName="totaalRestantPga"
            id="totaalRestantPga"
            prefix="€"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-2"></div>
      </div>
    }
  </form>

  <snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="lg" size="lg" title="Specificatie overige persoonsgebonden aftrek">
    <snelstart-ui-dialog-body>
      <form [formGroup]="formGroup">
        <div>
          @if ((formGroup.controls.aftrekPerVerzorgingsdagWeekenduitgaven.value ?? 0) > 0) {
            <div class="row">
              <div class="col col-1">
                <p>Aftrek per verzorgingsdag</p>
              </div>
              <div class="col-2">
                <snelstart-ui-number-form-control
                  [decimals]="0"
                  [disabledControl]="true"
                  align="right"
                  class="custom-input-150"
                  formControlName="aftrekPerVerzorgingsdagWeekenduitgaven"
                  id="aftrekPerVerzorgingsdagWeekenduitgaven"
                  prefix="€"
                ></snelstart-ui-number-form-control>
              </div>
              <div class="col-2"></div>
            </div>
          }
          @if ((formGroup.controls.aftrekReiskostenWeekenduitgaven.value ?? 0) > 0) {
            <div class="row">
              <div class="col col-1">
                <p>Aftrek reiskosten</p>
              </div>
              <div class="col-2">
                <snelstart-ui-number-form-control
                  [decimals]="0"
                  [disabledControl]="true"
                  align="right"
                  class="custom-input-150"
                  formControlName="aftrekReiskostenWeekenduitgaven"
                  id="aftrekReiskostenWeekenduitgaven"
                  prefix="€"
                ></snelstart-ui-number-form-control>
              </div>
              <div class="col-2"></div>
            </div>
          }
          @if ((formGroup.controls.vergoedingWeekenduitgaven.value ?? 0) > 0) {
            <div class="row">
              <div class="col col-1">
                <p>Af: Ontvangen vergoeding </p>
              </div>
              <div class="col-2">
                <snelstart-ui-number-form-control
                  [decimals]="0"
                  [disabledControl]="true"
                  align="right"
                  class="custom-input-150"
                  formControlName="vergoedingWeekenduitgaven"
                  id="vergoedingWeekenduitgaven"
                  prefix="€ -"
                ></snelstart-ui-number-form-control>
              </div>
              <div class="col-2"></div>
            </div>
          }
        </div>
      </form>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons class="d-flex">
      <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
      <snelstart-ui-button icon="check" id="save" type="primary">
        Akkoord
      </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
  </snelstart-ui-dialog-definition>
}
